import { from, Observable, pipe, UnaryFunction } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { z } from 'zod';

/**
 * Apply a Zod schema to the response's JSON.
 *
 */
export function applySchema<T extends z.ZodTypeAny>(
  schema: T
): UnaryFunction<Observable<Response>, Observable<z.infer<T>>> {
  return pipe(
    switchMap<Response, Observable<unknown>>((response) =>
      from(response.json())
    ),
    map<unknown, T>((response) => schema.parse(response))
  );
}
